module.exports = __webpack_public_path__ + "static/media/new-logo-c-v.cc1589e9.png";